<template>
	<div :class="['group-232', className || '']">
		<div class="rectangle-80"></div>

		<div
			v-if="email1"
			class="email poppins-normal-black-16px"
		>
			{{ email1 }}
		</div>

		<input
			class="input-field"
			:type="type"
			:value="modelValue"
			:placeholder="email2"
			:autocomplete="autocomplete"
			:autocapitalize="autocapitalize"
			:spellcheck="spellcheck"
			@input="onInput"
			@focus="$emit('focus', $event)"
			@blur="$emit('blur', $event)"
			@keyup="onKeyup"
		/>
	</div>
</template>

<script>
export default {
	name: 'Group232',
	props: {
		email1: {
			type: String,
			default: '',
		},
		email2: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: 'text',
		},
		className: {
			type: String,
			default: '',
		},
		modelValue: {
			type: String,
			default: '',
		},
		// Для контроля автозаполнения/капитализации
		autocomplete: {
			type: String,
			default: 'off',
		},
		autocapacapitalize: { // опечатку исправим ниже
			type: String,
			default: 'off',
		},
		autocapitalize: {
			type: String,
			default: 'off',
		},
		spellcheck: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:modelValue', 'focus', 'blur', 'input', 'keyup'],
	methods: {
		onInput(event) {
			const value = event.target.value
			this.$emit('update:modelValue', value)
			this.$emit('input', value)
		},
		onKeyup(event) {
			this.$emit('keyup', event)
		},
	},
}
</script>

<style>
.group-232 {
	height: 90px;
	margin-left: 18px;
	margin-top: 51px;
	position: relative;
	width: 100%;
	max-width: 439px;
}

.rectangle-80 {
	background-color: #f7f8fa;
	border: 1px solid #d0d7de;
	border-radius: 40px;
	height: 54px;
	left: 0;
	position: absolute;
	top: 36px;
	width: 100%;
	max-width: 435px;
	transition: border-color 0.2s ease, 
              background-color 0.2s ease, 
              box-shadow 0.2s ease;
}

.email {
	left: 0;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 0;
}

.input-field {
	position: absolute;
	top: 36px;
	left: 0;
	width: 100%;
	max-width: 435px;
	height: 54px;
	background-color: transparent;
	border: none;
	border-radius: 40px;
	padding: 0 31px;
	outline: none;
	font-size: 15px;
	color: var(--black);
	z-index: 1;
}

.input-field::placeholder {
	color: var(--silver-chalice);
	opacity: 1;
}

.input-field:focus {
	outline: none;
}

/* Модификаторы */
.group-232.group-225 {
	margin-top: 30px;
}

.group-232.group-226,
.group-232.group-226-1 {
	left: 0;
	margin-left: unset;
	margin-top: unset;
	position: absolute;
	top: 0;
}

.group-232.group-225-1 {
	margin-top: 83px;
}

/* Адаптивность */
@media (max-width: 767px) {
	.group-232 {
		margin-left: 0;
		width: 100%;
		max-width: 100%;
	}
	.rectangle-80,
	.input-field {
		width: 100%;
		max-width: 100%;
	}
}
</style>
